// features/user/userThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchUserDetails = createAsyncThunk(
  "user/fetchUserDetails",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("token")
    try {
      const response = await fetch("https://v3.dhundhoo.com/ev/getUserDetails", {
        method: "POST",
        headers: {
            "x-dhundhoo-session" : token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ timeZone: null }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch user details");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
